
<template>

  <div class="ui stackable grid">

    <!-- Title and ehdaa -->
    <div class="eleven wide column">
      <span class="ui almarai yellow big text">ختمة قرآنية</span>
      <br>
      <span class="ui almarai white big header">
        <span class="ui almarai white tiny text">تهدى هذه الختمة إلى:</span>
        <br>
        {{ khatma.ehdaa }}
      </span>
    </div>

    <!-- Counter -->
    <div class="five wide column">
      <Counter :khatma="khatma" />
    </div>

  </div>

</template>

<script>
import Counter from '@/components/Khatmat/Counter';

export default {

  name: 'KhatmaItem',
  components: {

    Counter

  },
  props: {

    khatma: Object

  }

}
</script>

<style scoped>
.white {
  color: white !important;
}
</style>
